<table datatable [dtOptions]="dtOptions" class="row-border hover " width="100%">

    <tbody>
        <tr *ngFor="let item of data" (click)="onClickRow(item)">

            <td style="cursor: pointer;" *ngFor="let column of columns">{{ item | flattenObject: column }}</td>
        </tr>
    </tbody>
    <!-- <tfoot>
        <tr>
            <th *ngFor="let column of columns" class="padding-mrp-table">
                <mat-form-field class="col-12 padding-mrp-table">
                    <input matInput type="text" placeholder="{{ column.title }}" name="{{ column.data }}" />
                </mat-form-field>
            </th>
        </tr>

    </tfoot> -->
</table>